import {RequestFilter} from "@/lib/store/state/filters/RequestFilter";

export class BasicFilter extends RequestFilter<string> {
    serialize(): string {
        return this.value;
    }
}
